import {downloadArrayBuffer} from "@Common/utils/browser/download-array-buffer";

import {downloadAsZip} from "./download-as-zip";

export const downloadProds = async (urls, itemId, sides, onDownloadProgress=null) => {
    if (urls && Array.isArray(urls) && sides){
        if (urls.length>1) {

            // fake the download progress - need to replace downloadAsZip with separate process to capture actual downloads
            onDownloadProgress && onDownloadProgress(1);

            await downloadAsZip(
                urls.map((url, index) =>({
                    url,
                    filePath: `${itemId}_${sides[index]}.pdf`,
                })),
                {fileName: `${itemId}_Proofs.zip`}
            );

            onDownloadProgress && onDownloadProgress(101); // progress to 101 sets as faked meter with slower transition

        } else if (urls[0]){

            // use xhr so that progress can be found
            let xhr = new XMLHttpRequest();
            await new Promise((resolve) => {
                xhr.responseType = "blob";

                // add handler for download progress if function provided
                if (onDownloadProgress) {
                    xhr.addEventListener("progress", (event) => {
                        if (event.lengthComputable) {
                            onDownloadProgress(Math.round(event.loaded / event.total * 100));
                        }
                    });
                }

                // display PDF and resolve promise after completion
                xhr.addEventListener("loadend", () => {
                    downloadArrayBuffer(xhr.response, {fileName: `${itemId}.pdf`})
                    resolve(true);
                });

                // start download
                xhr.open("GET", urls[0], true);
                xhr.send();

            });

        }
    }
};
